// ============================================================
// GOOGLE REVIEWS
// ============================================================
// Direct Google Maps listing for "Bombay Bespoke Fashion House LLC"
// (uses the verified Place CID — opens straight to your business panel).
export const GOOGLE_REVIEWS_URL =
  'https://www.google.com/maps?cid=10617305285746562930';

// Live verified Google rating (scraped from the public Maps panel).
// Update `total` when you cross the next review milestone.
export const GOOGLE_RATING = {
  score: 4.7,
  total: null, // hide review count until verified
};

// Real 5-star Google reviews for Bombay Bespoke Fashion House LLC.
// Home shows the first 3; Testimonials page shows all.
export const GOOGLE_REVIEWS = [
  {
    name: 'Celica Escobar',
    when: '10 months ago',
    rating: 5,
    isLocalGuide: true,
    text:
      "Very low key tailor shop but the BEST. HIDDEN GEM for very professional and high profile expats in Dubai. The owner Mr Gil is also super hands on, it’s like your go-to community doctor for your tailoring needs. Very friendly, down to earth, very patient with my own designs. Once he gives his 1st tailor made suit, you'll definitely ask for 5 more suits! Very rare to find a tailor for ladies like me. 1000% TOP! And price wise — affordable but the BEST QUALITY and CRAFT!",
  },
  {
    name: 'Ankur Mahajan',
    when: '8 months ago',
    rating: 5,
    isLocalGuide: true,
    text:
      "Bespoke Bombay Tailor in Dubai is one of the best tailoring experiences I’ve ever had. The craftsmanship is exceptional, and the attention to detail is top class. What truly sets them apart is the personal touch from the owner, Mr. Gill. He is one of the most humble and genuine people you’ll meet — he treats you with respect, listens carefully to your needs, and makes you feel completely at ease. He personally ensured my suit was tailored to perfection and, to my surprise, delivered it in just 2 days. The fit was flawless, the fabric quality was excellent, and the overall experience felt premium yet warm. Highly recommend.",
  },
  {
    name: 'khadzy 73',
    when: '5 months ago',
    rating: 5,
    text:
      "Absolutely bespoke when it comes to their quality in material and exquisite customer experience. Highly recommended to match every element in all of your special occasions. Mr. Gill has been extremely professional throughout the entire buying process and he has a splendid fashion knowledge — tops the chart when it comes to suggesting the right fit for me.",
  },
  {
    name: 'Nigel Smith',
    when: 'A year ago',
    rating: 5,
    text:
      "I purchased my first made-to-measure work suit from Mr. Gill in 2011. Since then he has been with two other outlets prior to owning Bespoke Bombay. Over the years, I have followed Mr. Gill and never bought tailored attire from anywhere else. I have recently taken delivery of two work suits, five work shirts, four casual shirts and two pairs of quality casual trousers — all look great and fit me perfectly. The customer service he and his team offer, along with an eye for detail and the quality of fabric, really mean I will only go to Mr. Gill and Bespoke Bombay. Truly an outstanding team providing outstanding service.",
  },
  {
    name: 'Levin Lal',
    when: '8 months ago',
    rating: 5,
    isLocalGuide: true,
    text:
      "Had a wonderful experience with Bombay Bespoke for our wedding! The service was exceptional, and Mr. Gill, the owner, personally guided us in selecting everything we needed for the occasion. His professionalism, patience, and eye for detail made the entire process effortless and enjoyable. Highly recommended for anyone planning their wedding.",
  },
  {
    name: 'Abhishek Manoj',
    when: '10 months ago',
    rating: 5,
    text:
      "My fiancée and I recently had the pleasure of visiting Bombay Bespoke Fashion & Tailoring in Al Karama — and we were truly impressed. The store is conveniently located in a bustling, easy-to-reach area. Mr. Gill guided me through every stage, ensuring my attire perfectly aligned with my style and measurements. Bombay Bespoke offers true bespoke craftsmanship at a fair price, and we’ll certainly be returning — and recommending to our friends too.",
  },
];

// ============================================================
// INSTAGRAM VIDEO TESTIMONIALS
// ============================================================
// Each entry is a public Instagram post/reel URL. The embed script renders
// the native Instagram card (with audio/play controls).
export const INSTAGRAM_TESTIMONIAL_EMBEDS = [
  { url: 'https://www.instagram.com/p/DZIL36ONymc/' },
  { url: 'https://www.instagram.com/p/DTPhiackk98/' },
  { url: 'https://www.instagram.com/p/DSLFMBxksNV/' },
  { url: 'https://www.instagram.com/p/DNa0Xmsy1Vs/' },
  { url: 'https://www.instagram.com/p/DL71di0yGbd/' },
  { url: 'https://www.instagram.com/p/DLmRIw_SgNN/' },
  { url: 'https://www.instagram.com/p/DJO4IYlyL2J/' },
  { url: 'https://www.instagram.com/p/DG8NPk9SIyz/' },
  { url: 'https://www.instagram.com/p/DFdq35ozaxA/' },
  { url: 'https://www.instagram.com/p/DFXShlPyGi2/' },
  { url: 'https://www.instagram.com/p/DFXProTSYMO/' },
  { url: 'https://www.instagram.com/p/DCZ9NbGtYO4/' },
];
